import * as React from 'react';

import FileXbd32 from './FileXbd32';

export const fileXbd32 = () => <FileXbd32 />;

export default {
    title: 'Icon/Content/FileXbd32',
    component: FileXbd32,
    parameters: {
        notes: "`import FileXbd32 from 'box-ui-elements/es/icon/content/FileXbd32';`",
    },
};
